import { useAssetListFilter, useSetAssetListFilter } from '@gripp/shared-logic';
import { useTranslation } from 'react-i18next';
import { EntitySearchInput } from './entitySearchInput';

export const AssetSearchInput = ({ onBlur, autoFocus }: { onBlur?: () => void; autoFocus?: boolean } = {}) => {
  const { t } = useTranslation();
  const { data: filter, isLoading } = useAssetListFilter();
  const { mutateAsync } = useSetAssetListFilter();

  const onSearch = async (keyword: string) => {
    if (!filter) return;
    filter.keyword = keyword;
    await mutateAsync(filter);
  };

  return (
    <EntitySearchInput
      filter={filter}
      onSearch={onSearch}
      placeholder={t('assets.filter.searchPlaceholder')}
      onBlur={onBlur}
      testID="asset-search-input"
      autoFocus={autoFocus ?? (!isLoading && !filter?.keyword)}
    />
  );
};
